export default "__VITE_ASSET__D05Piwr$__"